import {
    BookingDelayConfigurationModel,
    OdometerConfigurationModel,
    TwoFAConfigModel
} from "../../instance/models/instance.model";
import {DirectDebitfileConfigModel} from "../../instance/models/direct-debitfile-config.model";
import {VatDefaultModel, VatSettingsModel} from "../../vat-setting/models/vat-settings.model";
import {InvoiceSettingModel} from "../../invoicing-setting/models/invoicing-setting.model";
import {CustomeTripQuestion} from "../../pre-post-trip-question/models/custom-question.model";
import {PaymentProvider} from "./payment-provider";
import {Country} from "./country";

export class CompanyModel {
    public companyID: number;
    public companyMasterHashId: string;
    public companyName: string;
    public ContactPersonHashID: string;
    public contactPersonName: string;
    public isActive: boolean;
    public companyAddressModel: CompanyAddressModel;
    public instanceId: string;
    public instanceHashId: string = "";
    public intanalOrganization: string;
    // public companyGeoLocationAddress: string;
    // public displaycompanyGeoLocationAddress: string;
    // public companyGeoLocationLatitude: number;
    // public companyGeoLocationLongitude: number;
    public isChecked: boolean;
    public officeStartTime: string;
    public officeEndTime: string;
    public frequency: string;
    public timeInterval: string;
    public thresholdFrequency: string;
    public thresholdTimeInterval: string;
    public companyNotificationRecepientsModel: CompanyNotificationRecepientsModel;
    public isInstanceOdometerConfiguration: boolean = false;
    public odometerConfigurationModel: OdometerConfigurationModel;
    public directDebitfileConfigModel: DirectDebitfileConfigModel;
    public directDebitFileEnabledOnInstance: boolean;
    public lowBatteryFlagRaised: string = "11.50";
    public lowBatteryFlagClear: string = "12.0";
    public bookingDelayConfig: BookingDelayConfigurationModel;
    public isDeletable: boolean;
    public isVatSettingAvailable: boolean = false;
    public vatSettingDefaultCost: boolean = true;
    public vatSettingsList: Array<VatSettingsModel>;
    public invoiceSettings: InvoiceSettingModel;
    public vatDefaultRate: VatDefaultModel;
    public parentCompanyName: string = "";
    public paymentSettingRequiredOnInstance: boolean;
    public isPaymentEnabled: boolean = false;
    public paymentSettingModel: PaymentSettingModel;
    public userBlockMessage: string = "";
    public customTripQuestionList: Array<CustomeTripQuestion>;
    public instanceName: string = "";
    public twoFAConfig: TwoFAConfigModel;

    constructor() {
        this.companyAddressModel = new CompanyAddressModel();
        this.companyNotificationRecepientsModel = new CompanyNotificationRecepientsModel();
        this.odometerConfigurationModel = new OdometerConfigurationModel();
        this.directDebitfileConfigModel = new DirectDebitfileConfigModel();
        this.bookingDelayConfig = new BookingDelayConfigurationModel();
        this.bookingDelayConfig.enabled = "INHERIT";
        this.vatSettingsList = new Array<VatSettingsModel>();
        this.invoiceSettings = new InvoiceSettingModel();
        this.vatDefaultRate = new VatDefaultModel();
        this.paymentSettingModel = new PaymentSettingModel();
        this.parentCompanyName = "";
        this.customTripQuestionList = new Array<CustomeTripQuestion>();
        this.twoFAConfig = new TwoFAConfigModel();
    }
}

export class CompanyAddressModel {
    public houseNo: string;
    public houseExtention: string;
    public street: string;
    public city: string;
    public zipCode: string;
}

export class CompanyNotificationRecepientsModel {
    public isNotificationEnabled = true;
    public isEmailEnabled: boolean = true;
    public weGoAdmin: boolean;
    public companyAdmin: boolean;
    public groupAdmin: boolean;
    public type: string;
}

export class
PaymentSettingModel {
    public environment: string;
    public invoicePaymentTermDays: string;
    public paymentLinkValidityDays: string;
    //public paymentMethods: string;
    public secret: string;
    public userName: string;
    public creditCardPayment: boolean = false;
    public initialPayment: boolean = false;
    public createBookingPayment: boolean = false;
    public startBookingPayment: boolean = false;

    // New properties for payment epic integration.
    public chamberOfCommerce: string;
    public paymentProvider: PaymentProvider
    public overviewUrl: string
    public emailAddress: string
    public phoneNumber: string
    public country: Country
    public paymentMethodList : string[]
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/company/models/company.model.ts